import React, { useState, useEffect } from 'react';

const StanMeni2 = ({ listings, onStanClick }) => {
  // Stanje za trenutni indeks slike
  const [currentImageIndex, setCurrentImageIndex] = useState(
    listings.map(() => 0) // Početni indeks za svaku stavku je 0
  );

  // Funkcija za promenu slike svakih 1.5 sekundi
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndexes) =>
        prevIndexes.map((index, i) =>
          (index + 1) % listings[i].images.length // Sledeći indeks slike
        )
      );
    }, 1500); // Promena slike svakih 1.5 sekundi

    return () => clearInterval(intervalId); // Očisti interval prilikom demontiranja
  }, [listings]);

  return (
    <div
      className="relative bg-gray-800 p-6 rounded-lg shadow-lg max-w-lg mx-auto border-2 border-pink-600 mt-8"
      style={{ boxShadow: '0 0 20px 4px rgba(225, 0, 85, 1)' }}
    >
      <h2
        className="absolute top-0 left-0 text-2xl font-bold text-white"
        style={{ zIndex: 10, marginTop: '-60px' }}
      >
        Najnoviji oglasi
      </h2>

      <ul className="space-y-4">
        {listings.map((listing, index) => (
          <li
            key={index}
            className="relative mb-4 flex items-center border border-pink-600 rounded-lg overflow-hidden transition-all duration-300 transform hover:scale-105 hover:rotate-1 hover:shadow-[0_0_30px_10px_rgba(225,0,85,0.8)]"
            onClick={() => onStanClick(listing)}
            style={{ zIndex: 1 }}
          >
            {/* Slika koja ide do kraja granice */}
            <div className="w-full h-36 sm:w-56 sm:h-24 flex-shrink-0 overflow-hidden rounded-l-lg relative">
              <img
                src={listing.images[currentImageIndex[index]]} // Koristi se trenutni indeks za svaku stavku
                alt={listing.title}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
              />
              {/* Podaci koji se prikazuju preko slike na hover */}
              <div className="absolute inset-0 bg-gray-900 bg-opacity-75 p-4 flex flex-col items-start justify-center opacity-0 hover:opacity-100 transition-opacity duration-500">
                <p className="text-xs sm:text-sm text-gray-300">Lokacija: {listing.location}</p>
                <p className="text-xs sm:text-sm text-gray-300">Površina: {listing.area} m²</p>
                <p className="text-xs sm:text-sm text-gray-300">Broj soba: {listing.rooms}</p>
                <p className="text-xs sm:text-sm text-gray-300">Godina izgradnje: {listing.year}</p>
              </div>
            </div>

            {/* Detalji o stanu sa strane - prikazuju se samo na većim ekranima */}
            <div className="relative p-4 flex-grow space-y-2 hidden sm:block">
              <h3 className="text-sm sm:text-lg font-semibold text-white truncate">
                {listing.title.includes('Novi Sad') ? (
                  <span className="text-white">* {listing.title} *</span>
                ) : (
                  listing.title
                )}
              </h3>
              <p className="text-sm sm:text-xl font-bold text-white truncate">
                {listing.price} €
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StanMeni2;
